
import Vue from 'vue';
import publicPortfolioSectionMixin from '~/components/partials/public-portfolio/mixins/publicPortfolioSectionMixin';

export default Vue.extend({
  name: 'PublicPortfolioEmptyWorkhistoriesTip',
  mixins: [publicPortfolioSectionMixin],
});
